<template>
  <div class="product-image-placeholder-wrapper" :class="[{ 'product-image-placeholder-wrapper--loading': !loaded || error }, wrapperClass]">
    <img v-bind="$attrs" :[attributeConfig.srcset]="advancedSrcObject.srcset" :sizes="sizes" :alt="alt" :loading="loading" @load="onLoaded" @error="onError" />
    <figure v-if="error" class="product-image-placeholder">Image failed to load</figure>
    <figure v-else-if="!loaded" class="product-image-placeholder">
      <VueSpinner :color="spinnerColor" />
    </figure>
  </div>
</template>

<script>
import { buildUrlObject } from "@imgix/vue";
import { VueSpinner } from "vue3-spinners";

const DEFAULT_PARAMS = {
  auto: "compress,format",
  fit: "max",
};

export default {
  inheritAttrs: false,

  components: {
    VueSpinner,
  },

  props: {
    alt: {
      type: String,
      default: "Image",
    },

    imgixParams: {
      type: Object,
      default: () => {},
    },

    path: {
      type: String,
      required: true,
    },

    sizes: {
      type: String,
      default: "(min-width: 600px) 50vw, (min-width: 900px) 33vw, 100vw",
    },

    loading: {
      type: String,
      default: "lazy",
    },

    spinnerSize: {
      type: String,
      default: "48",
    },

    spinnerColor: {
      type: String,
      default: "#ff523f",
    },

    wrapperClass: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loaded: false,
      error: false,
    };
  },

  computed: {
    attributeConfig() {
      return { src: "src", srcset: "srcset" };
    },

    advancedSrcObject() {
      return buildUrlObject(this.path, this.imgixParams, {
        widths: [512, 1024, 2048, 4096],
      });
    },

    ixParams() {
      let params = { ...DEFAULT_PARAMS, ...this.imgixParams };
      return params;
    },
  },

  watch: {
    advancedSrcObject(newVal, oldVal) {
      this.loaded = false;
      this.error = false;
    },
  },

  methods: {
    onLoaded() {
      this.loaded = true;
    },

    onError() {
      this.error = true;
    },
  },
};
</script>
<style type="text/css">
.product-image-placeholder-wrapper {
  position: relative;
}
.product-image-placeholder-wrapper--loading {
  background: #f4f5f8;
  position: relative;
}
.product-image-placeholder {
  left: calc(50% - 8px);
  position: absolute;
  top: calc(50% - 8px);
  z-index: 1000;
}
</style>
